import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { autoAssignAgentFailure } from 'redux/slice/field/FieldPlanner.slice';
import { setUniqueValues } from 'redux/slice/filter/Filter.slice';
import { RootReducerState } from 'redux/slice/reducer';

const selectUniqueValues = (state: RootReducerState) =>
  state.filter.uniqueValues;

function* setUniqueValuesSaga(
  action: PayloadAction<any>
): Generator<any, void, any> {
  try {
    const uniqueValues = yield select(selectUniqueValues);
    // message.success('Filtered unique values fetched successfully');
  } catch (error: any) {
    yield put(autoAssignAgentFailure(error?.message));
    message.error('Failed to fetch filtered unique values');
  }
}

export function* watchFilterSagas() {
  yield takeLatest(setUniqueValues.type, setUniqueValuesSaga);
}
